export const reasonsList = [
    { label: "Mantenimiento programado", value: "Mantenimiento programado" },
    { label: "Limpieza programada", value: "Limpieza programada" },
    { label: "Fumigacion", value: "Fumigacion" },
    { label: "Por incidencia", value: "Por incidencia" },
    { label: "Otro", value: "Otro" },
]

export const options = [
    {
        label: "Preparada",
        icon: "check",
        key: "preparada",
    },
    {
        label: "Limpieza",
        icon: "broom", 
        key: "limpieza",
    },
    {
        label: "Pendiente de supervisión",
        icon: "SearchWatch", 
        key: "supervision_pendiente",
    },
    {
        label: "Sucia",
        icon: "trashFilled",
        key: "sucia",
    },
]
